import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/dist/query/react';
import { EventQueryArgs, EventResponse } from '../models';
import { getSettings, SettingsState } from '@vxui/common';

const rawBaseQuery = fetchBaseQuery();
const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const settings = getSettings(api.getState() as SettingsState);
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = `${settings?.servers.serverTranscoderConfigurator ?? ''}/api/v1/${urlEnd}`;
  const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };
  return rawBaseQuery(adjustedArgs, api, extraOptions);
};

export const eventsTag = 'EventsList' as const;

export const eventsApi = createApi({
  reducerPath: 'eventsApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: [eventsTag],
  endpoints: builder => ({
    getEvents: builder.query<EventResponse, EventQueryArgs>({
      query: ({ page, perPage, ...other }) => {
        const params = {
          page,
          pageSize: perPage,
          ...other,
        };
        return `events?${Object.keys(params)
          .filter(key => params[key as keyof typeof params] !== undefined)
          .map(key => `${key}=${params[key as keyof typeof params]}`)
          .join('&')}`;
      },
      providesTags: [eventsTag],
      transformResponse: (baseQueryReturnValue: EventResponse) => (!baseQueryReturnValue ? {} : baseQueryReturnValue),
    }),
  }),
});

export const { useGetEventsQuery } = eventsApi;
